<template>
  <div class="tab-pane fade" id="nav-charges" role="tabpanel" aria-label="nav-charges-tab">
    <!-- View and Search charges header -->
    <div class="container-fluid">
      <div id="vc_accordion" class="accordion border border-light rounded">
        <div class="card mb-0">
          <!-- <div class="card-header collapsed col-sm-12" data-toggle="collapse" href="#collapseOne"> -->
          <div class="card-header collapsed col-sm-12" data-toggle="collapse">
            <div class="row">
              <div class="col-sm-4">
                <p>View Charges</p>
              </div>
              <div class="col-sm-4">
                <div class="search_75">
                  <form class="input-group md-form form-sm">
                    <input
                      class="form-control form-control-sm search"
                      name="search"
                      placeholder="Search"
                      autocomplete="off"
                      type="text"
                      v-model="chargesSearch"
                    />
                    <div class="input-group-btn">
                      <a href="#" role="button">
                        <i class="fa fa-search active" aria-hidden="true"></i>
                      </a>
                    </div>
                  </form>
                </div>
              </div>
              <div class="col-xs-12 col-sm-4 mobile-space-t">
                <button
                  type="button"
                  data-toggle="collapse"
                  data-target=".sh_search"
                  class="more btn btn-hc-nb float-right"
                ></button>
              </div>
            </div>
            <div class="sh_search collapse show mt-3">
              <div class="row">
                <div class="col-12 col-sm-6">
                  <div class="row">
                    <div class="col-sm-6 mb-2">
                      <a
                        @click="last30Days"
                        role="button"
                        class="btn btn-hc-outline btn-block no-pad"
                      >Last 30 days</a>
                    </div>
                    <div class="col-sm-6 mb-2">
                      <a
                        @click="last6Months"
                        role="button"
                        class="btn btn-hc-outline btn-block no-pad"
                      >
                        Last 6
                        months
                      </a>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6 mb-2">
                      <a
                        @click="last12Months"
                        role="button"
                        class="btn btn-hc-outline btn-block no-pad"
                      >
                        Last 12
                        months
                      </a>
                    </div>
                    <div class="col-sm-6 mb-2">
                      <a
                        @click="clearFilters"
                        role="button"
                        class="btn btn-hc-outline btn-block no-pad"
                      >
                        Clear
                        filters
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="row">
                    <div class="col mb-2">
                      <el-date-picker
                        v-model="date"
                        format="dd.MM.yyyy"
                        type="daterange"
                        start-placeholder="Start date"
                        end-placeholder="End date"
                        :default-time="['00:00:00', '23:59:59']"
                      ></el-date-picker>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <form action>
                        <div class="form-group">
                          <b-form-select
                            v-if="nominalCodes"
                            v-model="selected"
                            class="form-control mb-2"
                          >
                            <option value="null">-- Type Of Charge --</option>
                            <option v-for="code in nominalCodes" :key="code.Id">{{code.Description}}</option>
                          </b-form-select>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- View and Search charges header end -->
    <div class="row pt-2">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12">
            <div class="col-sm-5 my-auto pt-3">
              <div>
                <h5 class="d-inline-block">Charges</h5>
                <!-- <a href="#">
                                  <img src="@/assets/img/add_icon_hcg.png" alt="Add Icon" data-toggle="modal" data-target="#addCharge" class="pl-2 d-inline-block">
                                </a>
                <add-charge></add-charge>-->
                <a class="btn btn-hc-nb" role="button" @click="$bvModal.show('addCharge')">
                  <img
                    src="@/assets/img/add_icon_hcg.png"
                    class="pl-2 d-inline-block"
                    alt="Add Icon"
                    data-toggle="modal"
                    data-target="#addCharge"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Need to sort this as the layout breaks! -->
    <!-- <div class="row mt-3">
                        <div class="col-12 my-auto">
                          <h5 class="d-inline">Charges</h5>
                            <a href="#">
                              <img src="@/assets/img/add_icon_hcg.png" class="pl-2 d-inline-block" alt="Add Icon" data-toggle="modal" data-target="#addACharge">
                            </a>
                        </div>
    </div>-->
    <!-- row close -->
    <div class="table-div mt-3 pl-3 pr-3" v-if="charges.length > 0">
      <b-table
        class="table-scroll tbl-sml"
        striped
        text-center
        :items="filteredCharges"
        :fields="chargeFields"
      >
        <!-- :current-page="currentPage" :per-page="7"> -->
        <template slot="ChargeStartDate" slot-scope="data">
          <div v-if="data.item.ChargeStartDate">{{data.item.ChargeStartDate | moment("DD.MM.YY")}}</div>
        </template>
        <template slot="Duration" slot-scope="data">
          <div>{{wordSplit(data.item.Duration)}}</div>
          <span v-if="data.item.Duration != 'Adhoc'">
            <div
              v-if="data.item.hasOwnProperty('ChargeEndDate')"
            >End Date {{data.item.ChargeEndDate | moment("DD.MM.YY")}}</div>
          </span>
        </template>
        <template slot="Amount" slot-scope="data">
          {{data.item.Amount | currency}}
          <!-- This is only shown if notes have been made on the charges screen -->
          <!-- From here -->
          <span v-if="data.item.Notes" class="d-inline">
            <span v-b-popover.click.hover.right="data.item.Notes" title="Notes" class="pointer">
              <i class="fas fa-sticky-note ml-1"></i>
              <i class="fas fa-pencil-alt"></i>
            </span>
          </span>
          <!-- to here -->
        </template>
        <template slot="BilledOnStatement" slot-scope="data">
          <div
            v-if="data.item.BilledOnStatement"
          >{{billingInfo(data.item.BilledOnStatement)[0].StatementNumber}}</div>
        </template>
        <template slot="action" slot-scope="data">
          <a
            v-if="!data.item.BilledOnStatement"
            href="#"
            data-toggle="modal"
            data-target="#DeleteCharge"
            id="Reverse"
            @click="rowClicked(data.item)"
          >
            <img src="@/assets/img/remove_icon.png" />
          </a>
        </template>
      </b-table>
    </div>
    <div class="row" v-else>
      <div class="col-12">
        <div class="h-100">
          <div class="d-flex h-100 justify-content-center align-items-center">
            <img
              src="@/assets/img/tick_selector.png"
              class="img-fluid d-inline-block"
              alt="No charges have been applied to this account"
            />
            <p class="d-inline-block my-auto pl-2">No charges have been applied to this account!</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import {
    _
  } from 'vue-underscore'
import _filters from "@/mixins/filters.js";

  export default {
    mixins: [_filters],
    data() {
      return {
        // charges,
        date: '',
        chargesSearch: '',
        currentPage: 1,
        selected: null,
        chargeFields: {
          ChargeStartDate: {
            label: 'Charge Start Date',
            sortable: true,
            'class': 'text-center'
          },
          Reason: {
            label: 'Type of Charge',
            'class': 'text-center'
          },
          Duration: {
            label: 'Charge Info',
            'class': 'text-center'
          },
          Amount: {
            label: 'Amount',
            'class': 'text-center'
          },
          BilledOnStatement: {
            label: 'Statement Number',
            'class': 'text-center'
          },
          action: {
            label: 'Delete Charge',
            'class': 'text-center'
          
        },
      },
    };
  },
  computed: {
    charges() {
      return this.$_.sortBy(this.$store.state.finances.charges, function (
        charge
      ) {
        return charge.ChargeStartDate;
      }).reverse();
    },
    bills() {
      return this.$store.state.finances.bills;
    },
    filteredCharges() {
      return this.dateFilter.filter((charge) => {
        return charge.Reason.match(new RegExp(this.chargesSearch, "i"));
      });
    },
    dateFilter: function () {
      if (!this.date) {
        return this.filteredType;
      }
      var that = this;
      return this.$_.filter(this.filteredType, function (charge) {
        return (
          moment(charge.ChargeStartDate).isSameOrAfter(that.date[0]) &&
          moment(charge.ChargeStartDate).isSameOrBefore(that.date[1])
        );
      });
    },
    filteredType() {
      if (this.selected == null || this.selected == "null") {
        return this.charges;
      }
      return _.where(this.charges, {
        Reason: this.selected,
      });
    },
    nominalCodes() {
      return this.$_.sortBy(
        this.$_.filter(this.$store.state.finances.nominals, function (nominal) {
          return nominal.Description !== null;
        }),
        "Description"
      );
    },
  },
  methods: {
    billingInfo(statementId) {
      return _.where(this.bills, {
        Id: statementId,
      });
    },
    last30Days: function () {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      return (this.date = [start, end]);
    },
    last6Months: function () {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
      return (this.date = [start, end]);
    },
    last12Months: function () {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
      return (this.date = [start, end]);
    },
    clearFilters: function () {
      this.date = null;
      this.selected = null;
    },
    rowClicked(item) {
      this.$store.commit("updateChargeDetails", item);
    },
  },
  created() {
    this.$store.dispatch("getNominals");
    this.$store.dispatch("getTaxes");
  },
};
</script>